import { ComponentClass, WeakValidationMap } from 'react';

import { NotifyData, StateData } from '@philips-emr/tws-core/lib/single-source-of-truth';
import { isEmptyObject, noop } from '@philips-emr/tws-utils';

import { EngineProps } from '../../renderer/react-renderer';

export default function (name: string, ComponentType: ComponentClass): ComponentClass<EngineProps> {

  const StatefulComponent = class extends ComponentType {

    props!: EngineProps;

    // @ts-ignore
    static get name(): string {
      return name;
    }

    // TODO: maybe unnecessary?
    static get propTypes(): WeakValidationMap<EngineProps> {
      return ComponentType.propTypes as WeakValidationMap<EngineProps>;
    }

    constructor(props: Readonly<EngineProps>) {
      super(props);
    }

    unsubscribe: Function = noop;

    componentDidMount(): void {
      const { ssot, onMount } = this.props;

      this.unsubscribe = ssot.subscribe(this.listenSSOT);

      onMount();

      if (super.componentDidMount) {
        super.componentDidMount();
      }
    }

    listenSSOT = ({ state }: NotifyData): void => {
      if (!isEmptyObject(state)) {
        super.setState(state);
      }
    };

    componentWillUnmount(): void {
      if (super.componentWillUnmount) {
        super.componentWillUnmount();
      }

      this.unsubscribe();
      this.props.onUnmount();
    }

    setState(partialState: Function | unknown, callback?: () => void): void {
      super.setState((...args: unknown[]) => {
        let result = partialState as StateData;
        if (typeof result  === 'function') {
          result = (partialState as Function)(...args);
        }
        this.props.ssot.apply(result);
        return result;
      }, callback);
    }

  };

  return StatefulComponent;
}
